export const config = {
    chainId:56 ,
    // chainId:97 ,
    networkName:"Binance Smart Chain",
    rpcUrl: "https://bsc-dataseed.binance.org/",
    // rpcUrl:'https://data-seed-prebsc-1-s1.binance.org:8545/',
    // contractAddress:"0xA4358D9F98788518e31816c447Aa3BAaE3E36dBd",
    contractAddress:"0x35BC16E232489Db391AC63Edc7920c556b5C9fbB",//main
    ICOContractAddress:'0xb2756fDB08527091f1e245508558C46dbFd37575',
}